<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.00004 18.3334C4.54171 18.3334 4.14948 18.1704 3.82337 17.8442C3.49726 17.5181 3.33393 17.1256 3.33337 16.6667V3.33341C3.33337 2.87508 3.49671 2.48286 3.82337 2.15675C4.15004 1.83064 4.54226 1.6673 5.00004 1.66675H15C15.4584 1.66675 15.8509 1.83008 16.1775 2.15675C16.5042 2.48341 16.6673 2.87564 16.6667 3.33341V16.6667C16.6667 17.1251 16.5037 17.5176 16.1775 17.8442C15.8514 18.1709 15.4589 18.334 15 18.3334H5.00004ZM9.16671 3.33341V8.43758C9.16671 8.60425 9.23282 8.72591 9.36504 8.80258C9.49726 8.87925 9.63948 8.87564 9.79171 8.79175L10.8125 8.18758C10.9514 8.10425 11.0939 8.06258 11.24 8.06258C11.3862 8.06258 11.5284 8.10425 11.6667 8.18758L12.6875 8.79175C12.8403 8.87508 12.9862 8.87869 13.125 8.80258C13.2639 8.72647 13.3334 8.6048 13.3334 8.43758V3.33341H9.16671Z" fill="#292D32"/>
  </svg>
</template>

<script>
export default {
  name: 'BookingsActiveIcon'
}
</script>
